import React, { useState, useRef } from 'react';
import { Select, Menu, MenuItem, FormControl, InputLabel, IconButton } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { getSelectOperators } from '../../list.functions';
import { useTranslation } from 'react-i18next';

const SelectOptionsFilter = ({ item, applyValue, onFilterOperatorChange, options }) => {
    const [operator, setOperator] = useState(item?.operator || 'equals');
    const [value, setValue] = useState(item?.value || '');
    const [focused, setFocused] = useState(false);
    const { t, i18n } = useTranslation();
    const operatorList = getSelectOperators(t)
    const getSafeTranslation = (key, fallback = key) => {
        const lang = i18n.resolvedLanguage || i18n.language || 'it';
        const translatedValue = i18n.getResource(lang, 'translation', key);
        return translatedValue !== undefined ? t(key) : fallback;
    };

    const inputRef = useRef(null);

    const handleValueChange = (event) => {
        const newValue = event.target.value;
        setValue(newValue);
        if (operator !== 'isEmpty' && operator !== 'isNotEmpty') {
            applyValue({ ...item, operator, value: newValue });
        }
    };

    const handleValueEmpty = () => {
        setValue('');
        applyValue({ ...item, value: '', operator: item?.operator })
    };

    const isValueInputDisabled = operator === 'isEmpty' || operator === 'isNotEmpty';
    const isValueEmpty = value === '' || value === null || value === undefined;

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOperatorChange = (operator) => {
        setOperator(operator);

        if (onFilterOperatorChange) {
            onFilterOperatorChange(operator);
        }

        if (operator === 'isEmpty' || operator === 'isNotEmpty') {
            applyValue({ ...item, operator: operator, value: ' ' });
        } else if (value) {
            applyValue({ ...item, operator: operator, value: value });
        }

        handleClose();
    };

    return (
        <FormControl variant="standard" size="small" className='mtska-list-filter-wrapper'>
            <InputLabel shrink={focused || !isValueEmpty}>{getSafeTranslation(operator)}</InputLabel>

            <Select
                variant="standard"
                size="small"
                className="mtska-list-filter-value"
                value={value}
                onChange={handleValueChange}
                inputRef={inputRef}
                disabled={isValueInputDisabled}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
            >
                <MenuItem value="">
                    {t('No selection')}
                </MenuItem>
                {(options ?? []).map((option, index) => (
                    <MenuItem key={option + index} value={option}>{getSafeTranslation(option)}</MenuItem>
                ))}
            </Select>

            <IconButton
                size="small"
                onClick={handleOpen}
            >
                <FilterListIcon fontSize="small" />
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {(operatorList ?? []).map((operator) => (
                    <MenuItem
                        key={operator.value}
                        value={operator.value}
                        onClick={() => handleOperatorChange(operator.value)}
                    >
                        {operator.label}
                    </MenuItem>
                ))}
            </Menu>
        </FormControl>
    );
};

export default SelectOptionsFilter;
